import { useEffect } from 'react';

const DEFAULT_TITLE = 'Dịch Tài Liệu — AI dịch Word, PowerPoint giữ nguyên format | dichtailieu.vn';
const DEFAULT_DESC  = 'AI dịch tài liệu tiếng Anh ↔ tiếng Việt. Giữ nguyên format Word, PowerPoint 100%. 10 trang/phút. Chính xác hơn Google Translate, rẻ hơn freelancer 10 lần.';

interface PageMetaOptions {
  noindex?: boolean;
}

export function usePageMeta(title: string, description: string, canonical?: string, options?: PageMetaOptions) {
  const noindex = options?.noindex ?? false;

  useEffect(() => {
    document.title = title;

    let metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (metaDesc) metaDesc.content = description;

    let ogTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
    if (ogTitle) ogTitle.content = title;

    let ogDesc = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
    if (ogDesc) ogDesc.content = description;

    let canonicalLink = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonicalLink && canonical) canonicalLink.href = canonical;

    let metaRobots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (metaRobots) metaRobots.content = noindex ? 'noindex, nofollow' : 'index, follow';

    return () => {
      document.title = DEFAULT_TITLE;
      if (metaDesc) metaDesc.content = DEFAULT_DESC;
      if (ogTitle) ogTitle.content = 'Dịch Tài Liệu — AI dịch Word, PowerPoint giữ nguyên format';
      if (ogDesc) ogDesc.content = DEFAULT_DESC;
      if (canonicalLink) canonicalLink.href = 'https://dichtailieu.vn/';
      if (metaRobots) metaRobots.content = 'index, follow';
    };
  }, [title, description, canonical, noindex]);
}
